import React, { Component } from 'react'
import { Button, Table } from 'reactstrap'
import { ExpressServerRoot } from '../constants'
import { apiRequest } from '../reducers/data'
const dateToInputString = (d) => d.toISOString().split('T')[0]

export default class DataContainer extends Component {
  state = {
    startDate: dateToInputString(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)),
    endDate: dateToInputString(new Date()),
    loading: false,
  }

  async runDataCleanUp() {
    console.log('DATA CLEANUP')
    if (
      confirm(
        'Are you sure you want to run the delete script? Please allow 10-30 seconds for the action to complete.'
      )
    ) {
      this.setState({ loading: true })
      let { json, response } = await window.store.dispatch(
        apiRequest(['export/clean_up'], 'DELETE')
      )

      console.log(response)
      console.log(json)
      alert(json.deleted.length + ' data rows have been deleted.')
      this.setState({ loading: false })
    }
  }

  render() {
    const { endDate, startDate } = this.state

    const Options = [
      {
        name: 'All Users Fitness Data (Zip of FitBit JSON, Folder per User)',
        url: 'zip-fitness-data',
      },
      {
        name: 'CSV - Demographics & Other',
        url: 'csv-users-demographics',
      },
      {
        name: 'CSV - User Activity [Date Range]',
        url: `all-users-activity?startDate=${startDate}&endDate=${endDate}`,
      },
      {
        name: 'CSV - User Badge Awards and Goal Notifications [Date Range]',
        url: `all-users-feed-entries?startDate=${startDate}&endDate=${endDate}`,
      },
      {
        name: 'CSV - RPE Self-assessment Scores [Date Range]',
        url: `all-users-rpe?startDate=${startDate}&endDate=${endDate}`,
        notes: 'Notes: Rating 1 is "VERY LIGHT", rating 5 is "EXTREMELY Hard"',
      },
      {
        name: 'CSV - EL-FIT Biweekly Merged [Date Range]',
        url: `csv-biweekly-merged?startDate=${startDate}&endDate=${endDate}`,
        notes:
          'Notes: BiWeek 0 begins on the selected start date. If you choose a date range that would result in the last 2 week period being less than 14 days, it is not included. To obtain a partial biweek, choose an end date in the future.',
      },
      {
        name: 'CSV - EL-FIT Long Daily [Date Range]',
        url: `csv-long-daily?startDate=${startDate}&endDate=${endDate}`,
      },
      {
        name: 'CSV - EL-FIT Long Minutes [Date Range]',
        url: `csv-long-minutes?startDate=${startDate}&endDate=${endDate}`,
      },
    ]

    return (
      <div id="DataContainer">
        <h3 className="tab-header">Data</h3>
        <Table className="table-element">
          <thead>
            <tr>
              <th style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>Export Type</div>
                {'Date Range: '}
                <input
                  value={startDate}
                  onChange={(e) => this.setState({ startDate: e.target.value })}
                  type="date"
                />
                {` — `}
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => this.setState({ endDate: e.target.value })}
                />
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {Options.map(({ name, url, notes }, i) => (
              <tr key={i}>
                <td>
                  {name}
                  <div style={{ color: '#666', fontSize: '0.9em', maxWidth: 700 }}>{notes}</div>
                </td>
                <td>
                  <a href={`${ExpressServerRoot}/api/dashboard/export/${url}`}>Download</a>
                </td>
              </tr>
            ))}
            {this.props.me.isAdmin ? (
              <tr>
                <td>
                  Data clean up script
                  <div style={{ color: '#666', fontSize: '0.9em', maxWidth: 700 }}>
                    This data clean up script will delete user_fitness_data older than two weeks
                    unless that user was part of a <a href="/studies">study</a> during that time.
                    TAKE A BACKUP FIRST
                  </div>
                </td>
                <td>
                  <Button
                    className="btn btn-danger"
                    disabled={this.state.loading}
                    onClick={() => this.runDataCleanUp()}
                  >
                    DELETE DATA
                  </Button>
                </td>
              </tr>
            ) : null}
          </tbody>
        </Table>
      </div>
    )
  }
}
